import * as React from 'react';
import { connect } from 'react-redux';

import { Container } from '../../components/Container';
import { Text } from '../../components/Text';
import { SIZE_24, SIZE_56 } from '../../constants/sizes';
import { IApplicationState } from '../../types/redux';
import { INewbuilding } from '../../types/newbuilding';
import { noop } from '@cian/newbuilding-utils';

import { GKCard } from './GKCard';
import { TTypedThunkDispatch } from '../../types/thunk';
import { trackingActionClickSimilarJK } from '../../actions/analytics';
import { IJsonQuery } from '../../utils/filters';

interface ISimilarNewbuildingsComponentStoreProps {
  similarNewbuildings: INewbuilding[];
  jsonQuery: IJsonQuery;
}
interface ISimilarNewbuildingsComponentOwnProps {
  hasNewbuildings: boolean;
}

interface ISimilarNewbuildingsComponentDispatchProps {
  trackingClickSimilarJK(newbuildingId: number, gaLabelFull: string, jsonQuery: IJsonQuery): void;
}

type TSimilarNewbuildingsComponentProps = ISimilarNewbuildingsComponentOwnProps
  & ISimilarNewbuildingsComponentStoreProps
  & ISimilarNewbuildingsComponentDispatchProps;

class SimilarNewbuildingsComponent extends React.PureComponent<TSimilarNewbuildingsComponentProps> {
  public render() {
    const {
      similarNewbuildings,
      hasNewbuildings,
      jsonQuery,
    } = this.props;

    if (!similarNewbuildings || !similarNewbuildings.length) {
      return null;
    }

    return (
      <>
        <Container
          dataMark="SimilarNewbuildings"
          margin={`${hasNewbuildings ? SIZE_56 : SIZE_24} 0 ${SIZE_24}`}
        >
          <Text
            fontSize={22}
            fontWeight="bold"
          >
            {hasNewbuildings
              ? 'Дополнительные предложения по вашему запросу'
              : 'Ничего не найдено, но есть похожие предложения'
            }

          </Text>
        </Container>
      <Container
        backgroundColor="white"
        borderStyle="solid"
        borderColor="gray_1"
        borderTopWidth={1}
        borderLeftWidth={1}
        borderRightWidth={1}
        borderBottomWidth={0}
      >
        {similarNewbuildings.map((newbuilding, index) => (
          <GKCard
            key={newbuilding.id}
            newbuilding={newbuilding}
            onPhoneButtonClick={noop}
            isEven={index !== 0 && index % 2 === 0}
            trackingOnCardClick={() => {
              this.props.trackingClickSimilarJK(
                newbuilding.id,
                newbuilding.gaLabels.full,
                jsonQuery,
              );
            }}
          />
        ))}
      </Container>
      </>
    );
  }
}

function mapStateToProps(state: IApplicationState): ISimilarNewbuildingsComponentStoreProps {
  return {
    similarNewbuildings: state.offersData.similarNewbuildings,
    jsonQuery: state.jsonQuery,
  };
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    trackingClickSimilarJK(newbuildingId: number, gaLabelFull: string, jsonQuery: IJsonQuery) {
      dispatch(trackingActionClickSimilarJK(newbuildingId, gaLabelFull, jsonQuery));
    },
  };
}

export const SimilarNewbuildings = connect(mapStateToProps, mapDispatchToProps)(SimilarNewbuildingsComponent);
